// Unfortunately our productGroup categories have spaces in them, so we aren't able to GraphQL enum them in CG.
export enum ProductGroupCategory {
  Accessories = 'Accessories',
  Embroidery = 'Embroidery',
  Gift = 'Gift',
  GiftCard = 'Gift Card',
  Hat = 'Hat',
  Jumpsuits = 'Jumpsuits',
  LabCoats = 'Lab Coats',
  Leggings = 'Leggings',
  Loungewear = 'Loungewear',
  Mask = 'Mask',
  Outerwear = 'Outerwear',
  Sample = 'Sample',
  ScrubCap = 'Scrub Cap',
  ScrubJacket = 'Scrub Jacket',
  ScrubPants = 'Scrub Pants',
  ScrubTop = 'Scrub Top',
  Shoes = 'Shoes',
  Socks = 'Socks',
  SportsBra = 'Sports Bra',
  StuffWeLike = 'Stuff We Like',
  Underscrub = 'Underscrub',
  Kit = 'Kit',
}

export enum Supercategory {
  Scrubs = 'Scrubs',
  Accessories = 'Accessories',
}

export const supercategories = {
  [Supercategory.Scrubs]: {
    text: 'Scrubs',
    path: { women: '/collections/all-scrubs-womens', men: '/collections/all-scrubs-mens' },
  },
}

export const breadcrumbData = {
  women: {
    key: 'women',
    collection: 'all-womens',
    category: {
      [ProductGroupCategory.Embroidery]: undefined,
      [ProductGroupCategory.Gift]: undefined,
      [ProductGroupCategory.GiftCard]: {
        key: ProductGroupCategory.GiftCard,
        collection: 'collections/figs-gift-cards',
        supercategory: undefined,
      },
      [ProductGroupCategory.Hat]: {
        key: ProductGroupCategory.Accessories,
        collection: '/collections/accessories-womens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Jumpsuits]: {
        key: ProductGroupCategory.Jumpsuits,
        collection: '/collections/scrub-jumpsuits-womens',
        supercategory: { key: Supercategory.Scrubs, collection: '/collections/all-scrubs-womens' },
      },
      [ProductGroupCategory.LabCoats]: {
        key: ProductGroupCategory.LabCoats,
        collection: '/collections/lab-coats-womens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Leggings]: {
        key: ProductGroupCategory.ScrubPants,
        collection: '/collections/scrub-pants-womens',
        supercategory: { key: Supercategory.Scrubs, collection: '/collections/all-scrubs-womens' },
      },
      [ProductGroupCategory.Loungewear]: {
        key: ProductGroupCategory.Loungewear,
        collection: '/collections/loungewear-womens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Mask]: {
        key: ProductGroupCategory.Accessories,
        collection: '/collections/accessories-womens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Outerwear]: {
        key: ProductGroupCategory.Outerwear,
        collection: '/collections/jackets-and-vests-womens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Sample]: undefined,
      [ProductGroupCategory.ScrubCap]: {
        key: ProductGroupCategory.ScrubCap,
        collection: '/collections/scrub-caps-pips',
        supercategory: { key: Supercategory.Accessories, collection: '/accessories-womens' },
      },
      [ProductGroupCategory.ScrubJacket]: {
        key: ProductGroupCategory.Outerwear,
        collection: '/collections/jackets-and-vests-womens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Accessories]: {
        key: ProductGroupCategory.Accessories,
        collection: '/collections/accessories-womens',
        supercategory: undefined,
      },
      [ProductGroupCategory.ScrubPants]: {
        key: ProductGroupCategory.ScrubPants,
        collection: '/collections/scrub-pants-womens',
        supercategory: { key: Supercategory.Scrubs, collection: '/collections/all-scrubs-womens' },
      },
      [ProductGroupCategory.ScrubTop]: {
        key: ProductGroupCategory.ScrubTop,
        collection: '/collections/scrub-tops-womens',
        supercategory: { key: Supercategory.Scrubs, collection: '/collections/all-scrubs-womens' },
      },
      [ProductGroupCategory.Shoes]: {
        key: ProductGroupCategory.Shoes,
        collection: '/collections/figs-new-balance',
        supercategory: undefined,
      },
      [ProductGroupCategory.Socks]: {
        key: ProductGroupCategory.Socks,
        collection: '/collections/socks-womens',
        supercategory: { key: Supercategory.Accessories, collection: '/accessories-womens' },
      },
      [ProductGroupCategory.SportsBra]: {
        key: ProductGroupCategory.Underscrub,
        collection: '/collections/underscrubs-womens',
        supercategory: undefined,
      },
      [ProductGroupCategory.StuffWeLike]: undefined,
      [ProductGroupCategory.Underscrub]: {
        key: ProductGroupCategory.Underscrub,
        collection: '/collections/underscrubs-womens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Kit]: {
        key: ProductGroupCategory.Kit,
        collection: '/collections/scrub-sets-womens',
        supercategory: { key: Supercategory.Scrubs, collection: '/collections/all-scrubs-womens' },
      },
    },
  },
  men: {
    key: 'men',
    collection: 'all-mens',
    category: {
      [ProductGroupCategory.Embroidery]: undefined,
      [ProductGroupCategory.Gift]: undefined,
      [ProductGroupCategory.GiftCard]: {
        key: ProductGroupCategory.GiftCard,
        collection: 'collections/figs-gift-cards',
        supercategory: undefined,
      },
      [ProductGroupCategory.Hat]: {
        key: ProductGroupCategory.Accessories,
        collection: '/collections/accessories-mens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Jumpsuits]: undefined,
      [ProductGroupCategory.LabCoats]: {
        key: ProductGroupCategory.LabCoats,
        collection: '/collections/lab-coats-mens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Leggings]: {
        key: ProductGroupCategory.ScrubPants,
        collection: '/collections/scrub-pants-mens',
        supercategory: { key: Supercategory.Scrubs, collection: '/collections/all-scrubs-mens' },
      },
      [ProductGroupCategory.Loungewear]: {
        key: ProductGroupCategory.Loungewear,
        collection: '/collections/loungewear-mens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Mask]: {
        key: ProductGroupCategory.Accessories,
        collection: '/collections/accessories-mens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Outerwear]: {
        key: ProductGroupCategory.Outerwear,
        collection: '/collections/jackets-and-vests-mens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Sample]: undefined,
      [ProductGroupCategory.ScrubCap]: {
        key: ProductGroupCategory.ScrubCap,
        collection: '/collections/scrub-caps-pips',
        supercategory: { key: Supercategory.Accessories, collection: '/accessories-mens' },
      },
      [ProductGroupCategory.ScrubJacket]: {
        key: ProductGroupCategory.Outerwear,
        collection: '/collections/jackets-and-vests-mens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Accessories]: {
        key: ProductGroupCategory.Accessories,
        collection: '/collections/accessories-mens',
        supercategory: undefined,
      },
      [ProductGroupCategory.ScrubPants]: {
        key: ProductGroupCategory.ScrubPants,
        collection: '/collections/scrub-pants-mens',
        supercategory: { key: Supercategory.Scrubs, collection: '/collections/all-scrubs-mens' },
      },
      [ProductGroupCategory.ScrubTop]: {
        key: ProductGroupCategory.ScrubTop,
        collection: '/collections/scrub-tops-mens',
        supercategory: { key: Supercategory.Scrubs, collection: '/collections/all-scrubs-mens' },
      },
      [ProductGroupCategory.Shoes]: {
        key: ProductGroupCategory.Shoes,
        collection: '/collections/figs-new-balance',
        supercategory: undefined,
      },
      [ProductGroupCategory.Socks]: {
        key: ProductGroupCategory.Socks,
        collection: '/collections/socks-mens',
        supercategory: { key: Supercategory.Accessories, collection: '/accessories-mens' },
      },
      [ProductGroupCategory.SportsBra]: undefined,
      [ProductGroupCategory.StuffWeLike]: undefined,
      [ProductGroupCategory.Underscrub]: {
        key: ProductGroupCategory.Underscrub,
        collection: '/collections/underscrubs-mens',
        supercategory: undefined,
      },
      [ProductGroupCategory.Kit]: {
        key: ProductGroupCategory.Kit,
        collection: '/collections/scrub-sets-mens',
        supercategory: { key: Supercategory.Scrubs, collection: '/collections/all-scrubs-mens' },
      },
    },
  },
  unisex: {
    key: undefined,
    collection: undefined,
    category: {
      [ProductGroupCategory.Embroidery]: undefined,
      [ProductGroupCategory.Gift]: undefined,
      [ProductGroupCategory.GiftCard]: {
        key: ProductGroupCategory.GiftCard,
        collection: 'collections/figs-gift-cards',
        supercategory: undefined,
      },
      [ProductGroupCategory.Hat]: undefined,
      [ProductGroupCategory.Jumpsuits]: undefined,
      [ProductGroupCategory.LabCoats]: undefined,
      [ProductGroupCategory.Leggings]: undefined,
      [ProductGroupCategory.Loungewear]: undefined,

      [ProductGroupCategory.Mask]: undefined,
      [ProductGroupCategory.Outerwear]: undefined,
      [ProductGroupCategory.Sample]: undefined,
      [ProductGroupCategory.ScrubCap]: {
        key: ProductGroupCategory.ScrubCap,
        collection: '/collections/scrub-caps-pips',
        supercategory: undefined,
      },
      [ProductGroupCategory.ScrubJacket]: undefined,
      [ProductGroupCategory.Accessories]: undefined,
      [ProductGroupCategory.ScrubPants]: undefined,
      [ProductGroupCategory.ScrubTop]: undefined,
      [ProductGroupCategory.Shoes]: {
        key: ProductGroupCategory.Shoes,
        collection: '/collections/figs-new-balance',
        supercategory: undefined,
      },
      [ProductGroupCategory.Socks]: undefined,
      [ProductGroupCategory.SportsBra]: undefined,
      [ProductGroupCategory.StuffWeLike]: undefined,
      [ProductGroupCategory.Underscrub]: undefined,
      [ProductGroupCategory.Kit]: undefined,
    },
  },
}
